import { createSelector, createFeatureSelector, ActionReducerMap } from '@ngrx/store';
import * as Reducer from './security-group.reducer';
import { ManagementModuleState } from '..';

export interface SecurityGroupState {
  securityGroups: Reducer.State;
}

const selectManagementModuleState = createFeatureSelector<ManagementModuleState>('management');

const selectSecurityGroupState = createSelector(selectManagementModuleState, (state: ManagementModuleState) => state?.security_groups);

export const selectSecurityGroups = createSelector(selectSecurityGroupState, Reducer.selectAll);

export const selectSelectedSecurityGroup = createSelector(selectSecurityGroupState, Reducer.getSelectedSecurityGroup);

export const selectSecurityGroupForDelete = createSelector(selectSecurityGroupState, Reducer.getSecurityGroupForDelete);

export const selectSecurityGroupMembers = createSelector(selectSecurityGroupState, Reducer.getSecurityGroupMembers);

export const selectSecurityGroupPermissionSets = createSelector(selectSecurityGroupState, Reducer.getSecurityGroupPermissionSets);

export const selectQueryParams = createSelector(selectSecurityGroupState, Reducer.getQueryParams);

export const selectMemberListQueryParams = createSelector(selectSecurityGroupState, Reducer.getMemberListQueryParams);

export const selectShowSecurityGroupForm = createSelector(selectSecurityGroupState, Reducer.getShowSecurityGroupForm);

export const selectEditSection = createSelector(selectSecurityGroupState, Reducer.getEditSection);

export const selectIsDirty = createSelector(selectSecurityGroupState, Reducer.getIsDirty);

export const selectIsPermissionSetsDirty = createSelector(selectSecurityGroupState, Reducer.getIsPermissionSetsDirty);

export const selectShowAddMembersForm = createSelector(selectSecurityGroupState, Reducer.getShowAddMembersForm);

export const selectSecurityGroupTypeFilter = createSelector(selectSecurityGroupState, Reducer.getSecurityGroupTypeFilter);

export const selectSearchTerm = createSelector(selectSecurityGroupState, Reducer.getSearchTerm);
